import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        getAllRoels: builder.mutation({
            query: (body) => ({
                url: `role/getAllRoles`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        addRole: builder.mutation({
            query: (body) => ({
                url: `role/addRole`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateRolePermission: builder.mutation({
            query: (body) => ({
                url: `role/updateRolesPermissions`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getRoleById: builder.mutation({
            query: (body) => ({
                url: `role/getRoleById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateRole: builder.mutation({
            query: (body) => ({
                url: `role/updateRole`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getUsersByRole: builder.mutation({
            query: (body) => ({
                url: `role/getUserListByRole`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
    })
})

export const { useGetAllRoelsMutation, useAddRoleMutation, useUpdateRolePermissionMutation, useGetRoleByIdMutation, useUpdateRoleMutation, useGetUsersByRoleMutation } = Api
